import React, { useEffect, useState, useCallback,useContext } from "react";
import style from "../../../styles/mystyle.module.css";
import AllMealsCards from "./AllMealsCards";
import SearchDietOrder from "./SearchDietOrder";
import { useRouter } from "next/router";
import MenuItemList from "./MenuItemList";
import TermsContext from "../../../context/Trems"
import { getCookieValue } from "../../helpers/helpers";
import axios from 'axios'
import { getImage } from '../../helpers/images'
import * as config from '../../../next.config'
import SystemConfigration from '../../../context/SystemConfigration'
import { useInfiniteQuery } from '@tanstack/react-query'
import { useInView } from 'react-intersection-observer'
import Loading from "../../../components/components/Loaders/Loading";
function CategoriesComponent(props) {
  const {ref,inView}=useInView()
  const router = useRouter();
  const [LoadMore, setLoadMore] = useState(false);
  const [loading, setloading] = useState(false);
  const [pageId4, setpageId4] = useState(1);
  const [NotFound, setNotFound] = useState(false);
  // const { t } = useTranslation("common");
  const [productList3, setproductList3] = useState([]);
  const [searchMealName2, setsearchMealName] = useState("");
  let entityId = props.entityId;
  const [levelTwo, setLevelTwo] = useState(props.levelTwo);
  const [levelThree, setLevelThree] = useState(props.levelThree);
  const [cateCode,setCateCode]=useState([])
  const systemConfig=useContext(SystemConfigration)
  // const loadMoreData = async() => {
  //   let tempPageId3 = pageId + 1;
  //   setpageId(prev=>prev+1)
  //   setpageId4(tempPageId3)
  //   setloading(true)
  //   if(cateCode.length>0){
  //         let categoriesfChildrenAndParent= getCategoriesChildrenWithParent(cateCode)
  //         await getproduct(tempPageId3, categoriesfChildrenAndParent.map(ele=>ele.id));
  //       }
  //  else if(props.Categories.length>0){
  //     let categoriesfChildrenAndParent= getCategoriesChildrenWithParent([props.Categories[0].code])
  //     await getproduct(tempPageId3, categoriesfChildrenAndParent.map(ele=>ele.id));
  //     }
  //     if([props.selectedLevelOneName].length>0&&cateCode.length==0){
  //       let categoriesfChildrenAndParent= getCategoriesChildrenWithParent([props.selectedLevelOneName])
  //       await getproduct(tempPageId3, categoriesfChildrenAndParent.map(ele=>ele.id));
  //     }
  // }
  const searchMealName =  useCallback(
    async callback => {
 
      setsearchMealName(callback);
      setproductList([])
      setLoadingData(true)

    },
    [searchMealName2, productList3]
  );
  const handleCallbackParent = async (name1,name,childData) => {
    // console.log("test=========>")
    setLoadingData(true)
    setCateCode([])
    setproductList([])
    setpageId(1)
    if(name.includes("all")&&name1){
      let categoriesfChildrenAndParent= getCategoriesChildrenWithParent(name1)
      setCategoriesIds(categoriesfChildrenAndParent.map(ele=>ele.id))

      setCateCode(name1)
    }
    else{
      let categoriesfChildrenAndParent= getCategoriesChildrenWithParent(name)
      setCategoriesIds(categoriesfChildrenAndParent.map(ele=>ele.id))
    
      setCateCode(name)
    }
}

function getCategoriesChildrenWithParent(category){
  let allCategories=[...props.Categories,...props.levelTwoCate,...props.levelThreeCate]
  let tempLstCategory=[]
  let categoryObj= allCategories.filter(ele=>category.includes(ele.code))
  if(categoryObj.length>0){
    tempLstCategory.push(...categoryObj)
  let listOFCategories1= allCategories.filter(ele=>category.includes(ele.field1))
 if(listOFCategories1.length>0){
    tempLstCategory.push(...listOFCategories1)
    let listOFCategories2=allCategories.filter(x=>listOFCategories1.map(ele=>ele.code).includes(x.field1))
    if(listOFCategories2.length>0){
      tempLstCategory.push(...listOFCategories2)
    }
 }
}
 return tempLstCategory.filter((i, x) => x ===tempLstCategory.findIndex(w =>w.id ===i.id))
}
const[categoriesIds,setCategoriesIds]=useState()

  useEffect(()=>{
    // console.log("categoriesIds========>",props,categoriesIds)
    setNotFound(false)
    if(props.hasOwnProperty('selectedLevelOneName')){
      setLoadingData(true)
      setproductList([])
      let categoriesfChildrenAndParent= getCategoriesChildrenWithParent([props.Categories[props.selectedLevelOneName]].map(ele=>ele&&ele.code))
      // console.log("categoriesfChildrenAndParent",categoriesfChildrenAndParent)
      setCategoriesIds(categoriesfChildrenAndParent.map(ele=>ele.id))
    }
    setCateCode([])
  },[props.selectedLevelOneName,systemConfig])
  let productCategories2 = [];
  let productCategoriesId = [];
  const [loadingData, setLoadingData] = useState(true);
  const [productList, setproductList] = useState([]);
  const [basketProductList, setBasketProductList] = useState([]);
  const [pageId, setpageId] = useState(1);
  const vocabTerms = useContext(TermsContext)
  const getproduct =async ({pageParam}) => {
    let status = vocabTerms.statusIds
    let searchData = {  
          entityDetailsId: JSON.stringify([entityId]),
          statusId: JSON.stringify(status),
          lang: router.locale,
          active:1,
          limit: 50,
          pageId: pageParam,
          joinProductUnitPrice: "",
          entityImageType:"logo",
          defaultPrice:1,
          feature:0  
        };
        let sysConfig=systemConfig.filter(ele=>ele.configKey=="excludedProductsFromView")
        if(sysConfig.length>0){
          sysConfig=sysConfig[0].configValue
          sysConfig=sysConfig.replace(/\\/g,'').replace(/"/g,'').split(',')
          searchData.notEqualcode = JSON.stringify(sysConfig)
        }
        if(categoriesIds&&categoriesIds.length>0){
          searchData.catIds = JSON.stringify(categoriesIds)
        }
        else{
          if(props.hasOwnProperty('selectedLevelOneName')){

          let categoriesfChildrenAndParent= getCategoriesChildrenWithParent([props.Categories[props.selectedLevelOneName]].map(ele=>ele&&ele.code))
          searchData.catIds=categoriesfChildrenAndParent.map(ele=>ele.id)
          }
        }
        if (getCookieValue("userCountry")) {
          searchData.userCountryCode = getCookieValue("userCountry")
        }
        if(searchMealName2){
          searchData.name=searchMealName2
        }

        return   await axios
        .get(`${config["basePath"]}/api/products/product/getProduct`,
            {
              params: searchData,
              headers: {
                "Content-Type": "application/json",
                "accept-language": router.locale
              },
              // signal:abortController.signal
            }
          )
          .then(async respEntityproducts => {
            
            let EntityProducts = respEntityproducts.data.data.data;
            setloading(false)
            if (EntityProducts.length > 0) {
              // EntityProducts.map(ele => {
              //   ele.productImages.map(async d => {
              //     if (d.files) {
              //       let fileString = d.files.filePath
              //       let rest = fileString.substring(0, fileString.lastIndexOf("/") + 1)
              //       let last = fileString.substring(fileString.lastIndexOf("/") + 1, fileString.length)
              //       let fileThumbnai = (rest + "thumbnail250/" + last)
              //       let img=await getImage(d.files.fileId, fileThumbnai)
              //       d.image = img
              //       return d
              //     }
              //   })
              // })
              
          let SearchDataPrice = { product: JSON.stringify(EntityProducts.map(i => i.id)),  statusId: JSON.stringify(status),getProductForFeature:"",getEntities:"",entityDetailsId: JSON.stringify([entityId]),getProductOffers:"",active:1}

          await axios.get(
            `${config["basePath"]}/api/products/productUnitPriceWithFeatures/get`,
            {
              params: SearchDataPrice
            }
          ).then(async proRes => {
       
            let tempResponse=proRes.data.data.data
                  if (tempResponse.length > 0) {
                      EntityProducts.map(i => {
                        i.OtherUnitsPrice = tempResponse.filter(
                          f => f.productId == i.id&&f.defaultPrice==false
                        );
                        i.productUnitPrice.map(r=>{
                          if(tempResponse.filter(
                            f => f.id == r.id
                          ).length>0){
                            r.ProductUnitPriceFeatures= tempResponse.filter(
                              f => f.id == r.id
                            )[0].ProductUnitPriceFeatures
                          }
                       
                        })
                      
                        return i;
                      });
                    }
                
          }).catch(err=>console.log(err))
              await axios
              .get(`${config["basePath"]}/api/products/offers/get`, {
                params: {
                  // display: 1,
                  active: 1,
                  statusId:JSON.stringify(vocabTerms.statusIds) ,
                  currentDate: new Date().getTime(),
                  productUnitPriceId: JSON.stringify(EntityProducts.map(i => i.productUnitPrice.filter(ele=>ele.defaultPrice)[0].id)),
                  entityDetailsId:JSON.stringify([entityId])
                }
              })
              .then(async offerRes => {
                if (offerRes.data.length > 0) {
                  let productOfferList = offerRes.data
                  if (productOfferList.length > 0) {
                    EntityProducts.map(i => {
                      i.productUnitPrice[0].productOffer = productOfferList.filter(
                        f => f.productUnitPriceId == i.productUnitPrice.filter(ele=>ele.defaultPrice)[0].id
                      );
                      return i;
                    });
  
                  }
                }
              })
              .catch(err => (err));
              productCategories2 = EntityProducts.map(
                x => x.productCategories
              );

              productCategories2.map(i => {
                i.map(p => {
                  {
                    productCategoriesId.push(p.productCategoriesId);
                  }
                });
              });
             
                setBasketProductList(prevState => [
                  ...prevState,
                  ...EntityProducts
                ])
        
                setproductList(EntityProducts);

                return respEntityproducts
            }
            else{
              return respEntityproducts
            }
          })
          .catch(err => console.log("err========>",err));
  
          };
    const info =useInfiniteQuery({queryKey: ['products',entityId,categoriesIds,searchMealName2],
    queryFn: getproduct,
    staleTime:10*(60*1000),
    cacheTime:10*(60*1000),
    initialPageParam:1,
    refetchOnWindowFocus:true,
    getNextPageParam: (lastPage, pages) => {
         if (50 == lastPage&&lastPage.data.data.pageable.numberOfElements) {
                if (50 * pages.length-1 < lastPage.data.data.pageable.totalElements) {
                  const nextPage= pages.length+1
                  return nextPage
                } 
              }
    }})
  
    useEffect(()=>{
      if(inView){
        info.fetchNextPage()
      }
    },[inView,info.hasNextPage])
  return (
    <div>
   
      <div className={style.allcard}>
    {props.subCat.length > 0 ? <MenuItemList levelThree={levelThree}  levelTwo={levelTwo} products={props.subCat}  parentCallback={handleCallbackParent} entityId={entityId} props={props}/>: ""}
     <SearchDietOrder searchMealName={searchMealName} />
     <AllMealsCards
      // products={productList && productList.length > 0 ? productList.filter((i, x) => x === productList.findIndex(w => w.id === i.id)): ""}
      products={info.data}
      Basketproducts={basketProductList}
      entityId={props.entityId}
      // loadMoreData={async()=>await loadMoreData()}
      loadMoreData={info.fetchNextPage}
      LoadMore={LoadMore}
      loading={loading}
      showloading={loadingData}
      WorkTime={props.WorkTime}
      Open={props.Open}
      NotFound={NotFound}
      entityDetails={props.entityDetails}
      info={info}
      >

<div ref={ref}>

{info.isLoading||info.isFetchingNextPage  == true ?
   <>
      <div style={{ textAlign: "center",display:"flex",justifyContent:"center" }}>
    {" "}
    
   <Loading /> 
  </div>
  </>
  : ""}
</div>
        {/* {   props.NotFound == true ?
              <p style={{ textAlign: "center", fontSize: " 1.2rem" }}>
                {" "}
                {t("Notfound")}
              </p>
            :""} */}
        </AllMealsCards>
    
      </div>{" "}
    </div>
  );
}

export default CategoriesComponent;
